import * as React from "react";
const SvgWarningAmber = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M23 21L12 2L1 21H23ZM4.47 19L12 5.99L19.53 19H4.47ZM13 16V18H11V16H13ZM13 10H11V14H13V10Z",
	fill: "#6384E0"
}));
export default SvgWarningAmber;
